import { ISelectType } from "@4uhub/lib4uhub";

export type TDashboardGenerateExecutionStatus =
  | "queued"
  | "processing"
  | "failed"
  | "finished"
  | "finishedwitherror";

export const DASHBOARD_GENERATE_EXECUTION_STATUS: TDashboardGenerateExecutionStatus[] =
  ["queued", "processing", "failed", "finished", "finishedwitherror"];

export interface IDashboardGenerateExecution {
  id: string;
  code: number;
  dashboardPanel: {
    id: string;
    code: number;
    name: string;
  };
  originGenerateDashboard: ISelectType;
  status: TDashboardGenerateExecutionStatus;
  totalGenerates: number;
  reducedGenerates: number;
  runningGenerates: number;
  failedGenerates: number;
  progress: number;
  finishedDate: string | null;
  generatesPurgedDate: string | null;
  created: string;
}

export interface IDashboardGenerate {
  id: string;
  eventDate: string | null;
  eventMonth: string | null;
  eventWeek: number | null;
  eventYear: number | null;
  batchNumber: number | null;
  batchTransaction: number | null;
  batchDate: string | null;
  retries: number;
  error: string | null;
  initialDate: string;
  endDate: string;
  initialProcessDate: string | null;
  endProcessDate: string | null;
  dashboardComponentCode: string;
  statusGenerateDashboard: ISelectType | null;
  dashboardGroupType: ISelectType | null;
  dashboardEstablishmentComponent: {
    id: string;
    code: string | null;
    name: string | null;
    dasdhboardName: string | null;
  };
  created: string;
}

export interface IDashboardGenerateConfig {
  id: string;
  maxBatchNumbers: number;
  maxBatchSize: number;
  maxRetries: number;
  maxPendingBatchTransactions: number;
  retentionDaysReduced: number;
  retentionDaysFailed: number;
  alertEmails: string | null;
}
